import { styled } from "styled-components";

const SvgDiv = styled.div<{
  $color?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.$color ?? "initial"};
  font-size: 40px;

  > * {
    width: 100%;
    height: 100%;
    object-fit: contain; 
  }
`;

export default SvgDiv;
